import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: ${tokens.typography.fontFamily.primary};
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .file-name {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    color: ${color.text.label};
    word-break: break-word;
  }

  .file-label {
    margin-right: 8px;
  }
`
